export function beforeSave(record) {
  const newRecord = { ...record };
  newRecord.upsAccount = record.upsAccount.id;
  return newRecord;
}
